module.exports = __webpack_public_path__ + "img/woman-handshake2.55c8a83f.webp";